<template>
  <div>
    <div class="order-main">
      <ul>
        <li>
          <div class="title">收货信息  </div>

          <div class="little-title">收货人:</div>
          <div class="cus-info" v-if="shipmentInfo.receiveName">
            {{ shipmentInfo.receiveName }}
          </div>
          <div class="little-title">联系电话:</div>
          <div class="cus-info" v-if="shipmentInfo.mobiletelephone">
            {{ shipmentInfo.mobiletelephone }}
          </div>
          <div class="little-title">收货地址:</div>
          <div class="cus-info" v-if="shipmentInfo.receiveAddress">
            {{ shipmentInfo.receiveAddress }}
          </div>
        </li>
        <li>
          <div class="title">付款信息</div>
          <div class="little-title">付款方式:</div>
          <div class="cus-info">{{ orderBaseInfo.payType }}</div>
          <div v-if="Number(orderBaseInfo.isOnLinePay) === 0 && orderBaseInfo.payerName">
            <div class="little-title">收款银行:</div>
            <eui-tooltip-over class="cus-info"
                              :line="2"
                              :tooltipStyle="{ width: '180px' }"
                              :content="orderBaseInfo.paymentRemark">
              <div>{{ orderBaseInfo.paymentRemark }}</div>
            </eui-tooltip-over>
            <div class="cus-info">{{ orderBaseInfo.payerName }}</div>
          </div>
          <div class="little-title">结算方式:</div>
          <div class="cus-info">{{ orderBaseInfo.isDoCStr }}</div>
          <div class="little-title">支付金额:</div>
          <div class="cus-info red">
            ¥{{ Number(orderBaseInfo.needPay).toFixed(2) }}
          </div>
          <div class="little-title" v-if="orderBaseInfo.otherPay == '1'">
            易权通转让:
          </div>
          <div class="cus-info red" v-if="orderBaseInfo.otherPay == '1'">
            {{Number(orderBaseInfo.otherNeedPay).toFixed(2)  }}
            <el-tooltip
              class="item"
              effect="dark"
              content="本订单含一定金额的易权通转让，买家将使用易权通额度完成部分订单额度支付，易权通可在平台中购买任意商品。"
              placement="top">
              <i class="el-icon-warning"></i>
            </el-tooltip>
          </div>
        </li>
        <li v-if="invoiceInfo">
          <div class="title">开票信息 </div>
          <div class="little-title">开票方式:</div>
          <div class="cus-info">{{ orderBaseInfo.invoiceModeCodeStr }}</div>
          <div class="little-title">开票节点:</div>
          <div class="cus-info">{{ invoiceInfo.invoiceMode ? invoiceInfo.invoiceModeStr :'' }}</div>
          <div class="little-title">发票信息: </div>
          <div class="cus-info"><span  class="invoice-detail" @click="showInvoiceDetail">发票详情</span> </div>

          <eui-tooltip-over class="cus-info"
                            :line="2"
                            :tooltipStyle="{ width: '180px' }"
                            :content="invoiceInfo.customer">
            <div>{{ invoiceInfo.customer }}</div>
          </eui-tooltip-over>

          <div class="cus-info">{{invoiceInfo.identificationNumber}} </div>
          <div class="cus-info">{{invoiceInfo.invoiceType == "101" ? "增值税普通发票": "增值税专用发票"}} </div>
        </li>
        <li>
          <div class="title">配送信息</div>
          <div class="little-title">配送方式:</div>
          <div class="cus-info">{{ orderBaseInfo.shipmentType == 1 ? "供应商配送" : "采购商自提" }}</div>
          <div class="little-title">期望到货日期:</div>
          <div class="cus-info">{{ orderBaseInfo.arriveTimeTxt }}</div>
        </li>
        <li>
          <div class="title">其他信息 </div>
          <div class="little-title">备注信息:</div>
          <div class="cus-info">{{ orderBaseInfo.remark }}</div>
          <div class="little-title">附件:</div>
            <div class="attach-box margin-t10" v-if="attachList.length > 0">
                <div class="attach-left">
                    <a target="_blank" :href="attachList[0].url">
                        <eui-tooltip-over class="file-name" :tooltipStyle="{ 'width': '130px' }"
                                          :content="attachList[0].name">
                            <span id="attachment">{{attachList[0].name}}</span>
                        </eui-tooltip-over>
                    </a>
                    <div class="margin-t4">
                        <div class="label-item" v-if="attachList[0].tags">{{attachList[0].tags}}</div>
                    </div>
                </div>
            </div>
            <eui-link lighten font-size="12px" v-if="attachList.length > 1" @click="labelVisible = true"> 查看更多
            </eui-link>

          <div class="little-title margin-b10" v-if="ecAndPetrolArr.length > 0">石化订单:</div>
            <div class="purchase-plan-box">
              <div v-for="(item,index) in ecAndPetrolArr" :key="index" class="flex-column-fs file-name"
                   @click="showPurchasePlan(item)">
                    {{item}}
                </div>
            </div>
        </li>
      </ul>
    </div>
    <invoice-detail-dialog :dialogVisible="invoiceVisible" :orderInvoiceVO="invoiceInfo" @closeDialog="closeDialog"/>
      <!-- 多个附件弹框-->
      <show-file-dialog
              v-if="labelVisible"
              :labelVisible.sync="labelVisible"
              :attachList="attachList"
      />
      <!--石化采购意向单弹框-->
      <stock-affirm-dialog
              v-if="stockAffirmVisible"
              :stockAffirmVisible.sync="stockAffirmVisible"
              :orderBaseInfo="orderBaseInfo"
      />
  </div>

</template>

<script>
  import invoiceDetailDialog from "./invoiceDetailDialog.vue";
  import showFileDialog from './showFileDialog';
  import stockAffirmDialog from './stockAffirmDialog';
  export default {
    name: "orderDetailShow",
    components: {invoiceDetailDialog, showFileDialog, stockAffirmDialog},
    props: {
      shipmentInfo: Object,
      orderBaseInfo: Object,
      invoiceInfo: Object,
    },
    data() {
      return{
        ecAndPetrolArr: [],
        labelVisible: false,
        attachList: [],
        invoiceVisible:false,
        stockAffirmVisible: false,
      }
    },
    methods: {
      showPurchasePlan() {
        this.stockAffirmVisible = true;
      },
      //查看发票详情
      showInvoiceDetail() {
        this.invoiceVisible = true;
      },
      closeDialog(){
        this.invoiceVisible = false;
      },
    },
    watch: {
      orderBaseInfo(val) {
        if (val.purchaseAttachList && val.purchaseAttachList.length > 0) {
          this.attachList = val.purchaseAttachList || [];
        }
        const ecAndPetroList = val.ecAndPetroList || [];
        this.ecAndPetrolArr = ecAndPetroList.map(item => item.stockAffirmId ? item.stockAffirmId : item.orderNo);
      },
    },
  }
</script>

<style scoped lang="scss">
@import '../../../../../assets/css/scrollbar.scss';
  .order-main {
    padding: 20px;
    border: 1px solid #d9d9d9;

      .purchase-plan-box {
          max-height: 40px;
          overflow-y: auto;
        color: #2587FF;
          div:hover {
              cursor: pointer;
          }
      }
      .attach-box {
          width: 100%;
          height: 60px;
          padding: 6px 10px 10px 10px;
          background: linear-gradient(90deg, #F5F5F5 0%, rgba(245, 245, 245, 0.20) 100%);
          margin-bottom: 6px;

          .attach-left {
              .margin-t4 {
                  margin-top: 4px;
              }

              .label-item {
                  width: 64px;
                  height: 20px;
                  border: 1px solid #D9D9D9;
                  margin-right: 6px;
                  color: #666;
                  text-align: center;
                  font-size: 12px;
                  cursor: pointer;
                  background-color: #fff;

                  &:hover {
                      background-color: #e9f3ff;
                      border-color: #2587FF;
                      color: #2587FF;
                  }
              }
          }

          .file-name {
              color: #0064C8;
              cursor: pointer;
              font-size: 14px;
              margin-top: 2px;
          }
      }
    ul {
      display: flex;
      justify-content: center;

      li {
        width: 250px;
        /*height: 400px;*/
        padding: 20px;
        border-right: 1px solid #d9d9d9;

        .title {
          width: 56px;
          height: 14px;
          font-size: 14px;
          font-weight: 500;
          color: #333333;
          line-height: 14px;
          padding-bottom: 20px;
        }

        .little-title {
          padding-top: 20px;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
        }
        .invoice-detail{
          color: #2f80ed;
          cursor: pointer;
          &:hover{
            border-bottom: 1px solid #2f80ed;
          }
        }
        .cus-info {
          font-size: 12px;
          font-weight: 400;
          color: #333333;
          margin-top: 4px;
        }
        .break{
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .red {
          color: red;
        }
      }

      li:first-child {
        padding-left: 0px;
      }

      li:last-child {
        border-right: none;
        word-wrap: break-word;
      }
    }
  }
</style>
